import moment from "moment";
import { BudgetPeriod } from "@/services/cloudchipr.api";

export const budgetPeriodUnits: Record<string, string> = {
  daily: "day",
  monthly: "month",
  quarterly: "quarter",
  annually: "year",
  custom: "custom",
};

export const budgetPeriods = Object.keys(budgetPeriodUnits) as BudgetPeriod[];

export const budgetCreateYears = Array(15)
  .fill(moment().year() - 5)
  .map((year, index) => year + index);

export const monthNames = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

export const getBudgetQuarters = (quarterStartMonth: number = 1) => {
  if (quarterStartMonth < 1 || quarterStartMonth > 12) {
    throw new Error("quarterStartMonth must be between 1 and 12");
  }

  const startIndex = quarterStartMonth - 1; // convert to 0-based

  const rotatedMonths = [
    ...monthNames.slice(startIndex),
    ...monthNames.slice(0, startIndex),
  ];

  return Array.from({ length: 4 }, (_, i) => {
    const startOffset = i * 3;
    const endOffset = startOffset + 2;

    return {
      firstMonthName: rotatedMonths[startOffset],
      lasMonthName: rotatedMonths[endOffset],
      quarterName: `Q${i + 1}`,
      firstMonthIndex: (startIndex + startOffset) % 12,
      lastMonthIndex: (startIndex + endOffset) % 12,
    };
  });
};
